import React, { useState } from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { showError } from "utils/notifications";
import FormSelect from "Common/Custom/FormSelect";

// Uses `fields` prop from parent — does not re-import JSON directly
const AddFloorAssignForm = ({
    fields = [],
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
    floorOptions = [],
    setValues,
}) => {
    // Single source of truth: derive the current room list from values.room_numbers
    // (a comma-joined string) instead of keeping a separate, easily-desynced state copy.
    const getRoomList = () =>
        values.room_numbers
            ? values.room_numbers.split(",").map((r) => r.trim()).filter((r) => r !== "")
            : [];

    const handleOnClickRemoveLastOne = (e) => {
        e.preventDefault();

        const currentRooms = getRoomList();

        if (currentRooms.length <= 1) {
            showError("At least one room number is required");
            return;
        }

        const updatedRooms = currentRooms.slice(0, -1);
        setValues((prev) => ({ ...prev, room_numbers: updatedRooms.join(",") }));
    };

    const handleOnClickNumberOfRooms = (e) => {
        e.preventDefault();

        const totalRooms = parseInt(values["no_of_room"], 10);
        const startNo = parseInt(values["start_no"], 10);

        if (!totalRooms || totalRooms <= 0) {
            showError("Please enter a valid number of rooms");
            return;
        }

        const generatedRooms = Array.from(
            { length: totalRooms },
            (_, i) => startNo + i
        );

        setValues((prev) => ({
            ...prev,
            room_numbers: generatedRooms.join(","),
        }));
    };

    return (
        <PageBody
            headerchildren={<HeadingOne>Add Floor Assign</HeadingOne>}
            onSubmit={handleSubmit}
        >
            {fields.map((field) => {
                if (field.type === "button") {
                    return (
                        <div key={field.name} className={`pt-md-2 ${field.fieldSize || "col-12"}`}>
                            <button
                                type="button"
                                className="btn btn-primary mt-md-4 me-2"
                                onClick={handleOnClickNumberOfRooms}
                            >
                                Add Number Of Room
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger mt-md-4"
                                onClick={handleOnClickRemoveLastOne}
                            >
                                <i className="fa fa-minus fs-6" />
                            </button>
                        </div>
                    );
                }

                if (field.name === "room_numbers") {
                    const roomList = getRoomList();

                    return roomList.map((roomNo, index) => (
                        <FormInput
                            key={`${field.name}_${index}`}
                            field={{
                                ...field,
                                name: `${field.name}_${index}`,
                                label: `Room No ${index + 1}`,
                            }}
                            value={roomNo}
                            handleChange={(e) => {
                                const updatedRooms = [...roomList];
                                updatedRooms[index] = e.target.value;

                                setValues((prev) => ({
                                    ...prev,
                                    room_numbers: updatedRooms.join(","),
                                }));
                            }}
                            error={errors[`${field.name}_${index}`]}
                        />
                    ));
                }

                if (field.type === "select" && field.name === "floor_name") {
                    const options = floorOptions.map((opt) => ({
                        value: opt.floor_id,
                        label: opt.floor_name,
                    }));
                    return (
                        <FormSelect
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            options={options}
                            error={errors[field.name]}
                        />
                    );
                }

                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Create Floor Assign"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default AddFloorAssignForm;
